// Libraries
import {
    Table,
    TableFilter,
    Popup,
    CreatePaymentLink,
    ViewEditPaymentLink,
    ViewPayments,
    ViewDownloadStatus,
} from '../../components';
import { STATUS_TYPE, PAY_TRANSACTION_STATUS } from '../../utils/constants/commonValues';
import React, { useMemo, useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

// Layouts

// Components

// Constants

// Actions

// Styles
import './paymentLink.scss';
import ReactDOM from 'react-dom';
import DownloadFile from './DownloadFile';
import {
    fetchPaymentLinkRequest,
    fetchMerchantTemplateRequest,
    generateReportRequest,
} from './redux/paymentLink.actions';

// Filters List for the payment link table.
const filterFieldList = [
    {
        fieldType: 'date',
        label: 'Date Range',
        name: 'createdOn',
        props: {},
    },
    {
        fieldType: 'input',
        label: 'Link Name',
        name: 'linkName',
        props: {
            placeholder: 'Enter Name',
        },
    },
    {
        fieldType: 'input',
        label: 'Link ID',
        name: 'linkId',
        props: {
            placeholder: 'Enter ID',
        },
    },
    {
        fieldType: 'radio',
        label: 'Status',
        name: 'status',
        props: {
            options: (function() {
                const options = [];
                for (const key in STATUS_TYPE) {
                    if (Object.prototype.hasOwnProperty.call(STATUS_TYPE, key)) {
                        const value = STATUS_TYPE[key];
                        options.push({
                            name: value,
                            value: key,
                        });
                    }
                }
                return options;
            })(),
            labelField: 'name',
            valueField: 'value',
        },
    },
];

// Filter List for the transactions view of payment link table.
const filterFieldListView = [
    {
        fieldType: 'date',
        label: 'Share On',
        name: 'createdOn',
        props: {},
    },
    {
        fieldType: 'input',
        label: 'Mobile / Email Id',
        name: 'communicationModeValue',
        props: {
            placeholder: 'Enter Email / Number',
        },
    },
    {
        fieldType: 'input',
        label: 'Transaction ID',
        name: 'transactionId',
        props: {
            placeholder: 'Enter ID',
        },
    },
    {
        fieldType: 'select',
        label: 'Status',
        name: 'transactionStatus',
        props: {
            data: (function() {
                const options = [];
                for (const key in PAY_TRANSACTION_STATUS) {
                    if (Object.prototype.hasOwnProperty.call(PAY_TRANSACTION_STATUS, key)) {
                        const value = PAY_TRANSACTION_STATUS[key];
                        options.push({
                            name: value,
                            value: key,
                        });
                    }
                }
                return options;
            })(),
            label: 'Select Status',
            labelField: 'name',
            valueField: 'value',
        },
    },
];

// Payment Link Table Action Popup.
const PaymentLinkActions = ({ data, fetchData, resetPage }) => {
    const [showFilter, setShowFilter] = useState(false);
    const [actionType, setActionType] = useState(null);

    const handleOpenActionPopup = actionType => {
        setShowFilter(true);
        setActionType(actionType);
    };

    const handleCloseOpenActionPopup = () => {
        setShowFilter(false);
        setActionType(null);
    };
    return (
        <div className="userAction multiItem">
            <button className="view" onClick={() => handleOpenActionPopup('view')} />
            <button
                className={`edit ${data.original.linkDataStatus === 'REVOKED' ? 'disabled' : ''}`}
                onClick={() => handleOpenActionPopup('edit')}
            />
            <button
                className={`share ${
                    data.original.linkDataStatus === 'INACTIVE' || data.original.linkDataStatus === 'REVOKED'
                        ? 'disabled'
                        : ''
                }`}
                onClick={() => handleOpenActionPopup('share')}
            />
            <Popup
                title={actionType === 'share' ? 'SHARE LINK' : data.original.linkName}
                actionType={actionType}
                showCloseIcon
                showOverlay
                showFilter={showFilter}
                data={data.original}
                closePopup={handleCloseOpenActionPopup}
            >
                <ViewEditPaymentLink
                    actionType={actionType}
                    data={data.original}
                    fetchData={fetchData}
                    resetPage={resetPage}
                    initialValues={data.original}
                    handleOpenActionPopup={handleOpenActionPopup}
                    closePopup={handleCloseOpenActionPopup}
                />
            </Popup>
        </div>
    );
};

const PaymentLink = props => {
    const {
        paymentLinkData,
        actions,
        loader: { showLoader },
    } = props;

    const { error, tableData, isLoading, pagination, generatedFile, activeReports } = paymentLinkData;

    const [filterData, setFilterData] = useState({});
    const [filterDataView, setFilterDataView] = useState({});
    const [showDownloadPopup, setShowDownloadPopup] = useState(false);

    const columns = useMemo(
        () => [
            { header: 'Link Name', accessor: 'linkName' },
            { header: 'Link ID', accessor: 'linkId' },
            { header: 'Created On', accessor: 'createdOn' },
            { header: 'Amount', accessor: 'amountView' },
            { header: 'Validity Period', accessor: 'validityPeriodView' },
            { header: 'Status', accessor: 'linkDataStatusView' },
            { header: 'Action', accessor: 'action' },
        ],
        []
    );

    const pageSizeOptions = [10, 20, 40, 60];

    // We'll start our table without any data
    const [pageCount, setPageCount] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [isResetPage, setIsResetPage] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [showFilter2, setShowFilter2] = useState(false);

    const handleViewDownloads = () => {
        setShowFilter(true);
    };

    const handleCloseViewDownloads = () => {
        setShowFilter(false);
    };

    const handleViewDownloadsTwo = () => {
        setShowFilter2(true);
    };

    const handleCloseViewDownloadsTwo = () => {
        setShowFilter2(false);
    };

    // Fetching table data function.
    const fetchData = useCallback(
        ({ pageSize, pageIndex }) => {
            // This will get called when the table needs new data
            // You could fetch your data from literally anywhere,
            const data = {
                pageSize,
                pageIndex,
            };
            actions.fetchPaymentLinkRequest({ ...data, ...filterData });
            setPageSize(pageSize);
        },
        [actions, filterData]
    );

    // Handle Pagination for the table
    useEffect(() => {
        setPageCount(Math.ceil(pagination.totalNumberOfRecords / pageSize));
    }, [pageSize, pagination.totalNumberOfRecords]);

    useEffect(() => {
        actions.fetchMerchantTemplateRequest();
    }, [actions]);

    return (
        <div className="paymentLink-wrapper">
            <Switch>
                <Route exact path="/payment-link">
                    <Table
                        tableTitle="Payment Link"
                        filterActionTitle="Create New Link"
                        columns={columns}
                        isFiltersEnable
                        isPaginationEnable
                        data={tableData}
                        filterData={filterData}
                        error={error && error.errorMessage}
                        loading={showLoader || isLoading}
                        pageCount={pageCount}
                        fetchData={fetchData}
                        numberOfRecord={pagination.totalNumberOfRecords}
                        pageSizeOptions={pageSizeOptions}
                        paginationLabel="Rows per page"
                        pagePerView={3}
                        isResetPage={isResetPage}
                        afterResetPage={() => setIsResetPage(false)}
                        onClickTableAction={handleViewDownloads}
                        userActions={data => (
                            <PaymentLinkActions
                                data={data}
                                fetchData={fetchData}
                                resetPage={() => setIsResetPage(true)}
                            />
                        )}
                        additionalActions={() => (
                            <div className="button-container payment-link">
                                <DownloadFile
                                    filterData={filterData}
                                    tableData={tableData}
                                    actions={actions}
                                    showDownloadPopup={showDownloadPopup}
                                    setShowDownloadPopup={setShowDownloadPopup}
                                    generateData={generatedFile}
                                    handleViewDownloads={handleViewDownloadsTwo}
                                />
                                <button
                                    className="custom-btn"
                                    id="next-btn"
                                    type="button"
                                    onClick={handleViewDownloadsTwo}
                                >
                                    VIEW DOWNLOADS
                                </button>
                            </div>
                        )}
                        tableActionPopup={
                            <React.Fragment>
                                <Popup
                                    title="CREATE NEW LINK"
                                    showCloseIcon
                                    showOverlay
                                    showFilter={showFilter}
                                    closePopup={handleCloseViewDownloads}
                                >
                                    <CreatePaymentLink
                                        closePopup={handleCloseViewDownloads}
                                        fetchData={fetchData}
                                        resetPage={() => setIsResetPage(true)}
                                    />
                                </Popup>
                                <Popup
                                    title="Download Status"
                                    showCloseIcon
                                    showOverlay
                                    showFilter={showFilter2}
                                    closePopup={handleCloseViewDownloadsTwo}
                                >
                                    <ViewDownloadStatus data={activeReports.reports} />
                                </Popup>
                            </React.Fragment>
                        }
                        tableFilters={
                            <TableFilter
                                customFilterClass="rightSkewed"
                                showOverlay
                                fieldsList={filterFieldList}
                                onSubmit={filterValues => {
                                    setFilterData(filterValues);
                                    setIsResetPage(true);
                                }}
                                onReset={resetValue => {
                                    setFilterData(resetValue);
                                    setIsResetPage(true);
                                }}
                            />
                        }
                    />
                </Route>
                <Route exact path="/payment-link/:linkDataId">
                    <ViewPayments
                        filterData={filterDataView}
                        tableFilters={
                            <TableFilter
                                customFilterClass="rightSkewed"
                                showOverlay
                                fieldsList={filterFieldListView}
                                onSubmit={filterValues => {
                                    setFilterDataView(filterValues);
                                    setIsResetPage(true);
                                }}
                                onReset={resetValue => {
                                    setFilterDataView(resetValue);
                                    setIsResetPage(true);
                                }}
                            />
                        }
                    />
                </Route>
            </Switch>
        </div>
    );
};

const mapStateToProps = ({ auth, paymentLinkData, loader, staticData }) => ({
    auth,
    paymentLinkData,
    loader,
    staticData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchPaymentLinkRequest,
            fetchMerchantTemplateRequest,
            generateReportRequest,
        },
        dispatch
    ),
});

PaymentLink.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    data: PropTypes.object,
    paymentLinkData: PropTypes.object,
    staticData: PropTypes.object,
    loader: PropTypes.object,
};

PaymentLinkActions.propTypes = {
    data: PropTypes.object,
    fetchData: PropTypes.func,
    resetPage: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentLink);
